export const LOTTERY_PERMISSION_GROUP = 'Lottery';
export const LIST_LOTTERIES_PERMISSION = 'LIST_LOTTERIES';

/** Roles & Permissions Terminal tab: system administrators only. */
export function canManageLotteryInRolesPage(isSuper?: boolean): boolean {
  return isSuper === true;
}

/** Left nav + lottery routes: system administrators (isSuper) only. */
export function canAccessLotteryFeature(isSuper?: boolean): boolean {
  return isSuper === true;
}
